import type { CSSProperties } from "react";
import { buttonLabelStyle } from "../render/blocks/button";
import { resolveButtonChrome } from "../domain/button-theme";
import { DEFAULT_BUTTON_TEXT_COLOR } from "../domain/factories";
import type { EmailSettings , ButtonBlock } from "../domain/types";

export function resolveInlineButtonLabelStyle(
  block: ButtonBlock,
  settings: EmailSettings,
): CSSProperties {
  const chrome = resolveButtonChrome(block, settings);
  return buttonLabelStyle(
    block,
    settings.bodyFontFamily,
    chrome.color ?? DEFAULT_BUTTON_TEXT_COLOR,
  );
}
